var map = {
	"./ClientMapping": 83349,
	"./CreditnoteMapping": 16527,
	"./DeliveryMapping": 8100,
	"./EstimateMapping": 70514,
	"./InvoiceMapping": 93995,
	"./OpportunityMapping": 93917,
	"./OrderMapping": 17110,
	"./PeopleMapping": 81441,
	"./ProformaMapping": 70016,
	"./PropdocumentMapping": 62516,
	"./ProspectMapping": 45476,
	"./PurCreditNoteMapping": 37200,
	"./PurDeliveryMapping": 60539,
	"./PurInvoiceMapping": 29826,
	"./PurOrderMapping": 74307,
	"./StaffMapping": 87976,
	"./SupplierMapping": 4560,
	"./ThirdMapping": 19293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91531;